import { ApiProperty } from "@nestjs/swagger";

export class SoakingSampleTestDTO{
    @ApiProperty()
    soakingSampleTestId: number;
    @ApiProperty()
    logId: number
    @ApiProperty()
    jobNumber: string;
    @ApiProperty()
    batchNoScode: string;
    @ApiProperty()
    bsTemp: number;
    @ApiProperty()
    bsCount: number;
    @ApiProperty()
    bsWeight: number;
    @ApiProperty()
    asTemp: number;
    @ApiProperty()
    asCount: number;
    @ApiProperty()
    asWeight: number;
    @ApiProperty()
    chemicalConsumptiona: number;
    @ApiProperty()
    chemicalConsumptionb: number;
    @ApiProperty()
    timeIn: Date;
    @ApiProperty()
    timeOut: Date;
    @ApiProperty()
    pickupPercentage: number;
    @ApiProperty()
    remarks: string;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    versionFlag: number;
}